import { render, staticRenderFns } from "./BetgameOrderAgreement.vue?vue&type=template&id=499e88b9&scoped=true"
import script from "./BetgameOrderAgreement.vue?vue&type=script&lang=js"
export * from "./BetgameOrderAgreement.vue?vue&type=script&lang=js"
import style0 from "./BetgameOrderAgreement.vue?vue&type=style&index=0&id=499e88b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499e88b9",
  null
  
)

export default component.exports